import "./App.css";
import { BrowserRouter as Router, Routes, useLocation } from "react-router";
import { useEffect } from "react";

import { generateRoutesFromConfig } from "utils/generateRoutesFromConfig";
import routes from "app/routes";

// this can be removed if all preline components reinitiliaze themselves
// in their own useEffect with the correct list of components to reinit.
function RouteWatcher() {
  const location = useLocation();
  useEffect(() => {
    if (window.HSStaticMethods?.autoInit) {
      window.HSStaticMethods.autoInit(["dropdown", "overlay"]);
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <>
      <Router>
        <RouteWatcher />
        <Routes>{generateRoutesFromConfig(routes)}</Routes>
      </Router>
    </>
  );
}
export default App;
